import glue from '@smartfire/glue-ui';

// Glue Project Configuration
// NOTE: Glue Translation support has been removed on backend
glue.setFrontAvailableTranslations(['fr']);
glue.setEditingAvailableTranslations(['fr']);
glue.setSmartFormStatus(true);
